import { useCallback, useState } from 'react'
import { PrescriptionFilesParams } from '../../../components/eprescription/OrdoclicIframe/OrdoclicIframe.model'
import { CustomFile } from '../../../model/File'
import { OrdoclicPrescriptionFile } from '../../../model/ordoclic'
import { queryClient } from '../../../queryClient'
import { medicalEventsActions } from '../../../store/cache/medicalEvents'
import { medicalEventsKeys } from '../../queries/medicalEvents/medicalEvents.keys'
import {
  CreatePrescriptionFilesMutateVariables,
  useCreatePrescriptionFiles,
} from '../../queries/ordoclic/useCreatePrescriptionFiles.query'
import { useActionDispatch } from '../useActionDispatch.hook'

export const useHandlePrescriptionFileGeneration = (
  medicalEventId?: number,
  patientId?: number,
) => {
  const [uniquePatientPrescriptionFilesCreated, setUniquePatientPrescriptionFilesCreated] =
    useState<CustomFile[]>()

  const resetPrescriptions = useCallback(() => setUniquePatientPrescriptionFilesCreated([]), [])

  const dispatchMedicalEventRefresh = useActionDispatch(
    medicalEventsActions.actions.apiGetItemDetails,
  )

  const { mutate: createPrescriptionFiles } = useCreatePrescriptionFiles()

  let args: CreatePrescriptionFilesMutateVariables

  const handlePrescriptionFileGeneration = (
    params: PrescriptionFilesParams,
    type: 'unique' | 'multi',
  ) => {
    switch (type) {
      case 'unique':
        args = [
          {
            ordoclicPatientId: params[0].ordoclicPatientId,
            prescriptionIds: params[0].prescriptionIds,
            medicalEventId: medicalEventId,
          },
        ]
        break
      case 'multi':
        args = params.map((param) => ({
          ...param,
          medicalEventId: medicalEventId,
        }))
        break
    }

    createPrescriptionFiles(args, {
      onSuccess: (prescriptions: OrdoclicPrescriptionFile[]) => {
        medicalEventId && dispatchMedicalEventRefresh(medicalEventId)

        if (type === 'unique' && prescriptions[0]?.files) {
          setUniquePatientPrescriptionFilesCreated(prescriptions[0].files)
        }

        prescriptions.forEach((prescription) => {
          queryClient.invalidateQueries({
            queryKey: medicalEventsKeys.list({ patientId: `${prescription.patientId}` }),
          })
        })
      },
    })
  }

  return {
    uniquePatientPrescriptionFilesCreated,
    handlePrescriptionFileGeneration,
    resetPrescriptions,
  }
}
